interface SummaryCardsProps {
  weighted: string;
  winRate: string;
  atRisk: number;
  salesVelocity: string;
  avgCycle: string;
}

export function SummaryCards({ weighted, winRate, atRisk, salesVelocity, avgCycle }: SummaryCardsProps) {
  return (
    <div className="grid grid-cols-5 gap-4">
      <div className="bg-white rounded-lg p-5 border border-gray-200 hover:border-gray-300 transition-colors">
        <p className="text-xs text-gray-500 mb-1">Weighted Pipeline</p>
        <p className="text-3xl text-gray-900">{weighted}</p>
      </div>
      
      <div className="bg-white rounded-lg p-5 border border-gray-200 hover:border-gray-300 transition-colors">
        <p className="text-xs text-gray-500 mb-1">Win Rate</p>
        <p className="text-3xl text-gray-900">{winRate}</p>
      </div>
      
      <div className="bg-white rounded-lg p-5 border border-gray-200 hover:border-rose-300 transition-colors">
        <p className="text-xs text-gray-500 mb-1">At-Risk Opportunities</p>
        <p className="text-3xl text-rose-600">{atRisk}</p>
      </div>

      <div className="bg-white rounded-lg p-5 border border-gray-200 hover:border-gray-300 transition-colors">
        <p className="text-xs text-gray-500 mb-1">Sales Velocity</p>
        <p className="text-3xl text-gray-900">{salesVelocity}</p>
      </div>

      <div className="bg-white rounded-lg p-5 border border-gray-200 hover:border-gray-300 transition-colors">
        <p className="text-xs text-gray-500 mb-1">Avg Cycle</p>
        <p className="text-3xl text-gray-900">{avgCycle}</p>
      </div>
    </div>
  );
}
